import React from 'react'
import { useEffect } from 'react'
import ReactDOM from 'react-dom';
import env from "react-dotenv";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
  Link,
  useHistory,
  useLocation
} from "react-router-dom";
import './index.css';

import ReactGA from "react-ga4"
import TagManager from 'react-gtm-module'

import { Fragment, useState } from 'react'

import { HomepageApp } from './apps/homepage/HomepageApp';
import MarketplaceApp from './apps/marketplace/MarketplaceApp';
import DealPageTemplate from './apps/marketplace/DealPageTemplate';
import RegistrationApp from './apps/registration/RegistrationApp';
import LoginApp from './apps/login/LoginApp';
import ForgotApp from './apps/forgotpassword/ForgotApp';
import ConfirmApp from './apps/forgotpassword/ConfirmApp';
import VerifyAccountApp from './apps/verifyaccount/VerifyAccountApp';
import GiveawayApp from './apps/forms/giveaway1/GiveawayApp';
import reportWebVitals from './reportWebVitals';

import { UserProvider, useUser } from './apps/providers/UserProvider'
import { NotificationProvider, useNotification } from './apps/providers/NotificationProvider'
import { ThemeProvider, useTheme } from './apps/providers/ThemeProvider'
import { CookiesProvider, useCookies } from 'react-cookie';

import UserService from './apps/services/UserService'
import AffiliateService from './apps/services/AffiliateService'

import { library } from '@fortawesome/fontawesome-svg-core'
import { fab } from '@fortawesome/free-brands-svg-icons'

import {
  createHttpLink,
  InMemoryCache
} from '@apollo/client';

const queryString = require('query-string');

library.add(fab);

//ReactGA.initialize(env.GA_ID);
//ReactGA.send("pageview");
const tagManagerArgs = {
  gtmId: 'GTM-5RV42RS'
}

TagManager.initialize(tagManagerArgs)

window.dataLayer.push({
  event: 'pageview'
});

function requireAuth(nextState, replace, next) {
    replace({
      pathname: "/login",
      state: {nextPathname: nextState.location.pathname}
    });
  next();
}


function App() {
  let loggedIn = false;
  let token = localStorage.getItem('AUTH_TOKEN');
  let preferences = localStorage.getItem('preferences');
  const location = useLocation();
  let query = location.search;
  let pathname = location.pathname;

  const history = useHistory();

  const [ cookies, setCookie, removeCookie ] = useCookies([]);
  const [user, userDispatch] = useUser();
  const [ notification, notify ] = useNotification();
  const [ theme, themeDispatch ] = useTheme();

  if (token) {
    loggedIn = true;
  }

  useEffect(() => {
    // Do not show banner on login/registration page.
    const paths = pathname.split('/')
    if (paths.length > 1) {
      if (!['register', 'login', 'signin', 'forgot', 'verify',].includes(paths[1]))
        notify({ type: "notification/message", payload: { message: 'HIGHLIGHT_PRODUCT_REQUEST_FEATURE' } })
    }

    if (query) {
      let params = queryString.parse(query);
      if (params._a) {
        setCookie('affiliate-link', params._a);
      }
    }

    if (preferences) {
      themeDispatch({ type: 'theme/set', payload: JSON.parse(preferences) });
    }

    if (token) {
      userDispatch({ type: 'user/login' });

      UserService.me(token).then((response) => {
        if (response.data.errors || response.data.data.me === null) {
          localStorage.removeItem('AUTH_TOKEN');
          notify({type: "show_error", payload: { message: "Session Timed out."  } })
          history.replace('/login');
        } else {
          userDispatch({
            type: 'me',
            payload: response.data.data
          });
          if (response.data.data.me.affiliateId !== null) {
            let pref = AffiliateService.getBrandingByRefId(response.data.data.me.affiliateId);

            localStorage.setItem('preferences', JSON.stringify(pref));
            themeDispatch({
              type: 'theme/set',
              payload: pref
            });
          }
          /*
          if (response.data.data.me.coi !== null) {
            localStorage.setItem('preferences', JSON.stringify(response.data.data.me.coi));
            themeDispatch({
              type: 'theme/set',
              payload: response.data.data.me.coi
            });
          }
          */
        }
      }).catch(() => {
        localStorage.removeItem('AUTH_TOKEN');
        notify({type: "notify/error", payload: { message: "Session Timed out."  } })
        history.replace('/login');
      });
    }
  }, []);

  return (
    <div>
      <Switch>
        <Route path={["/register/:affiliateId", "/register",]}>
          {!loggedIn ? <RegistrationApp /> : <Redirect push to="/marketplace" /> }
        </Route>

        <Route path={["/giveaway1"]}>
          {!loggedIn ? <GiveawayApp /> : <Redirect push to="/marketplace" /> }
        </Route>

        <Route path="/login">
          {loggedIn ? <Redirect push to="/marketplace" /> : <LoginApp /> }
        </Route>

        <Route path="/signin">
          <LoginApp />
        </Route>

        <Route path="/forgot">
          {!loggedIn ? <ForgotApp /> : <Redirect push to="/marketplace" /> }
        </Route>

        <Route path="/reset">
          <ConfirmApp />
        </Route>

        <Route path="/verify">
          {!loggedIn ? <VerifyAccountApp /> : <Redirect push to="/marketplace" /> }
        </Route>
        
        <Route exact path={["/marketplace/:vendorName/:offerTitle/:dealId"]} component={DealPageTemplate} />

        <Route exact path={["/marketplace", "/marketplace/category/:catSlug", "/marketplace/:dealSlug/:dealId", "/marketplace/search"]} component={MarketplaceApp} />

        <Route path="/">
          <HomepageApp />
        </Route>

      </Switch>
    </div>
  )
}

ReactDOM.render(
  <React.StrictMode>
    <Router>
      <CookiesProvider>
        <ThemeProvider>
          <NotificationProvider>
            <UserProvider>
              <App />
            </UserProvider>
          </NotificationProvider>
        </ThemeProvider>
      </CookiesProvider>
    </Router>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
